import React from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { generateRoutes } from '../util/functions/routeGenerators'
import { loginPath, navRoutes } from './routes'

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Navigate replace to={loginPath} />} />
        {generateRoutes(navRoutes)}
      </Routes>
    </BrowserRouter>
  )
}

export default AppRouter
